// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"e1a46df2","348":"14596f83","578":"0b9373a2","737":"79dc3da7","940":"80f201a4"}[chunkId] + ".chunk.js";
};